'use strict';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export var loggingService = function(configService) {

    const INFORMATIONAL = 1;
    const WARNING = 2
    var appInsightsKey = "";
    var appInsights = null;

    configService.getAppSettings().then(settings => {   
        appInsightsKey = settings.appInsightsKey;
        appInsights = new ApplicationInsights({ config: {
            instrumentationKey: appInsightsKey, 
            endpointUrl: settings.appInsightsURL
          } });
        appInsights.loadAppInsights();
    });

    function info(msg, properties) {
        if (appInsights) appInsights.trackTrace({message: msg, properties: properties});
        else console.info(msg, properties);
    }

    function warn(msg, properties) {
        if (appInsights) appInsights.trackTrace({message: msg, properties: properties});
        else console.warn(msg, properties);
    }

    function error(error, properties) {
        if (appInsights) appInsights.trackException({exception: error, properties: properties});
        else console.error(error, properties);
    }

    function flush() {
        if (appInsights) appInsights.flush();
    }

    return {
        info: info,
        warn: warn,
        error: error,
        flush: flush
    }
};

loggingService.$inject = ['configService']